<template>
  <div class="container-fluid mt--6" >
    <div class="abs-btn-grp" style="top:61px">
      <div class="dropdown map-trade">
        <button @click="mapTrades()" type="button" class="btn btn-success rounded"><i class="fas fa-user-plus"></i> MAP TRADES</button>              
        <button :disabled="loadingMark" @click="markTrades()" type="button" class="btn btn-warning rounded">
          <i v-if="!loadingMark" class="fas fa-check"></i> 
          <i v-if="loadingMark" class="fa fa-spinner fa-spin"></i> 
          MARK STAND-ALONE
        </button>              
        <button  :disabled="loadingUnmark" @click="unmarkTrades()" type="button" class="btn btn-danger rounded">
          <i v-if="!loadingUnmark" class="fas fa-times"></i> 
          <i v-if="loadingUnmark" class="fa fa-spinner fa-spin"></i> 
          UNMARK STAND-ALONE
        </button>               
        <!-- <button @click="toggleAddTradePoup()" type="button" class="btn btn-success rounded"><i class="fas fa-user-plus"></i> ADD NEW</button>              
        <button @click="deleteTrades()" type="button" class="btn btn-danger rounded"><i class="fas fa-trash"></i> DELETE TRADE</button>               -->
      
      </div>
      <div class="dropdown">
        <button  class="btn btn-white btn-sm rounded dropdown-toggle ml-2 mt-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <div>
            <i class="fas fa-ellipsis-v mr-1" ></i> ACTION
          </div>   
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item cursor-pointer" @click="toggleAddTradePoup()">ADD NEW</a>
          <a class="dropdown-item cursor-pointer" @click="deleteTrades()">DELETE TRADE</a>
          <a class="dropdown-item cursor-pointer" @click="remapTrades()">REMAP BY CUSIP</a>
        </div>
      </div>

    </div>
    <div class="filter-show">
        <div class="card w-100 p-2 mb-2  d-inline-block">
          <div class="d-flex bd-highlight">
            <h5 class="mt-2 p-2 flex-grow-1 bd-highlight">Filters</h5>
            <span class="btn btn-outline-secondary btn-sm rounded" @click="showFilters = !showFilters">
              <i class="fa mt-2" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
            </span>
          </div>
          <div class="row" v-if="showFilters">
            <div class="col-lg-12">
                <form class="row">
                    <div  class="col-md-2">
                        <label for="filter" class="col-form-label">Settlement From</label>
                        <datepicker v-model="fromDate"  name="fromDate" placeholder="mm/dd/yyyy" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                    </div>
                    <div  class="col-md-2">
                        <label for="filter" class="col-form-label">Settlement To</label>
                        <datepicker v-model="toDate" placeholder="mm/dd/yyyy"  name="toDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                    </div>
                    <div class="col-md-4 col-lg-4">
                        <label for="filter" class="col-form-label">Accounts</label>
                        <multiselect 
                            v-model="filterAccounts" 
                            placeholder="Select accounts" 
                            :options="accountList"  
                            :multiple="true" 
                            :limit="3"></multiselect>
                    </div>
                    <div class="col-md-4 col-lg-4">
                        <label for="filter" class="col-form-label">Cusip</label>
                        <!-- <input class="form-control"  maxlength="9" v-model="filterCusip"/> -->
                         <multiselect 
                          v-model="filterCusips" 
                          placeholder="Select cusips" 
                          :options="cusipList"
                          :multiple="true" 
                          :limit="3"></multiselect>
                    </div>
                  <div v-if="isAdmin || isSuperAdmin || isEditor" class="col-md-3">
                      <label for="filter" class="col-form-label">Trader</label>
                      <multiselect 
                        v-model="filterTrader" 
                        placeholder="Select traders" 
                        label="firstName" 
                        track-by="traderId"
                        :options="traderList"  
                        :multiple="true" 
                        :limit="3"  ></multiselect>
                    </div>
                    <div class="col-md-3">
                      <label for="filter" class="col-form-label">Transaction Type</label>
                      <multiselect 
                        v-model="filterTransactionType" 
                        placeholder="Select type" 
                        :options="transactionTypes"
                        :preserve-search="true"  
                        :multiple="true" 
                        :limit="3"  ></multiselect>
                    </div>
                    <div class="col-md-3">
                      <label for="filter" class="col-form-label">Settlement Status</label>
                      <multiselect 
                        v-model="filterSettlementStatus" 
                        placeholder="Select type" 
                        :options="settlementStatus"
                        :preserve-search="true"  
                        :multiple="false" 
                        :limit="3"  ></multiselect>
                    </div>
                    <!-- <div class="col-md-4 col-lg-2">
                    <div class="form-check mt-5">
                        <input id="Settled" type="checkbox"  class="form-check-input wh" v-model="isSettiled" >
                        <label for="Settled" class="form-check-label">Is Settled?</label>
                    </div>
                  </div> -->
                  <div class="col-md-4 col-lg-2">
                    <div class="form-check mt-5">
                        <input id="Ignored" type="checkbox"  class="form-check-input wh" v-model="isIgnored" >
                        <label for="Ignored" class="form-check-label">Is Ignored?</label>
                    </div>
                  </div>
                  <div class="col-md-4 col-lg-2 ">
                    <div class="form-check mt-5 d-flex align-items-end">
                        <input id="Removed" type="checkbox" @change="removedOptionChange()"  class="form-check-input wh" v-model="isRemoved" >
                        <label for="Removed" class="form-check-label">Is Removed?</label>
                    </div>
                  </div>
                  <div class="col-md-4 col-lg-2 ">
                    <div class="form-check mt-5 ml-1 d-flex align-items-end">
                        <input id="Stand" type="checkbox"   class="form-check-input wh" v-model="isStandAlone" >
                        <label for="Stand" class="form-check-label">Is Stand Alone?</label>
                    </div>
                  </div>
                    <div class="col-md-12" style="display:flex;justify-content:center">
                      <div>
                        <button @click="clearFilter()" type="button" class="btn btn-secondary rounded">Clear</button>
                        <button @click="getPLList()" type="button" class="btn btn-primary rounded">Filter</button>
                      </div>  
                  </div>
                </form>    
            </div>
          </div>
        </div>
      </div>
      <div class="row">
            <div class="col-xl-12">
              <div class="card vh-75" id="scroll">
                  <div class="table-responsive">
                  <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                  <table class="table align-items-center table-flush table-hover bidtbl">
                      <thead class="thead-light psticky">
                      <tr>
                         <th
                            scope="col" 
                            class="sort text-center"
                            >SELECT </th>
                          
                          <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'accountNo'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'accountNo'  ? 'sort-desc' : '']"  
                              @click="sort('accountNo')" >ACCOUNT <br> NO</th>
                          <th
                            scope="col" 
                            class="sort text-center"
                            >BUY/SELL </th> 
                            <!-- <th
                            scope="col" 
                            class="sort text-center"
                            >DRL <br>BUY/SELL </th>     -->
                            <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'tradeDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'tradeDate'  ? 'sort-desc' : '']"  
                              @click="sort('tradeDate')" >TRADE <br> DATE</th>  
                          <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'settlementDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'settlementDate'  ? 'sort-desc' : '']"  
                              @click="sort('settlementDate')" >SETTLEMENT <br> DATE</th>
                          <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusip'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cusip'  ? 'sort-desc' : '']"  
                              @click="sort('cusip')" >CUSIP</th>  
                          <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'quantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'quantity'  ? 'sort-desc' : '']"  
                              @click="sort('quantity')" >QTY</th>
                          <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'price'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'price'  ? 'sort-desc' : '']"  
                              @click="sort('price')" >PRICE</th> 
                          <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'principalAmnt'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'principalAmnt'  ? 'sort-desc' : '']"  
                              @click="sort('principalAmnt')" >PRINCIPAL <br> AMOUNT</th>
                          <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'interest'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'interest'  ? 'sort-desc' : '']"  
                              @click="sort('interest')" >INTEREST</th>
                          <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'commConcAmount'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'commConcAmount'  ? 'sort-desc' : '']"  
                              @click="sort('commConcAmount')" >COMMCON <br> AMOUNT</th>  
                          <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'referenceNo'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'referenceNo'  ? 'sort-desc' : '']"  
                              @click="sort('referenceNo')" >REF <br> NO</th>  
                          <!-- <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'primaryAcctHolder'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'primaryAcctHolder'  ? 'sort-desc' : '']"  
                              @click="sort('primaryAcctHolder')" >PRIMARY ACCOUNT HOLDER</th> -->
                          <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'acctType'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'acctType'  ? 'sort-desc' : '']"  
                              @click="sort('acctType')" >ACCOUNT <br> TYPE</th> 
                          <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'execBrokerMinor'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'execBrokerMinor'  ? 'sort-desc' : '']"  
                              @click="sort('execBrokerMinor')" >EXEC <br> BROKER <br>MINOR</th> 
                          <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'execBrokerMinor'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'execBrokerMinor'  ? 'sort-desc' : '']"  
                              @click="sort('securityType')" >Security <br> Type</th>
                          <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'execBrokerMinor'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'execBrokerMinor'  ? 'sort-desc' : '']"  
                              @click="sort('repCode')" >RR1</th>     
                          <th 
                              scope="col" 
                              class="sort text-center border-right"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'fbsiShortName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'fbsiShortName'  ? 'sort-desc' : '']"  
                              @click="sort('fbsiShortName')" >FBSI <br>SHORT <br>NAME</th> 
                          <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'settled'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'settled'  ? 'sort-desc' : '']"  
                              @click="sort('settled')" >SETTLED</th> 
                          <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'firstName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'firstName'  ? 'sort-desc' : '']"  
                              @click="sort('firstName')" >Trader</th>       
                          <th
                            scope="col" 
                            class="sort text-center">
                            ACTION
                          </th>                                     
                        
                      </tr>
                      </thead>
                      <tbody class="list no-cursor">
                      <tr v-if="totalRows == 0 && !loading">
                          <td><p class="nodata">No data available</p>
                          </td>
                      </tr>
                      <tr v-for="data in PlList" :key="data.id" v-bind:class="{'row-highlight-red' : data.highlight}">
                          <td class="text-center">
                            <input v-model="data.isSelect" type="checkbox" class="form-check-input" />
                          </td>
                          <td class="text-center">{{data.accountNo}}</td>
                          <td class="text-center">{{data.actionSb}}</td>
                          <!-- <td class="text-center">{{!data.sellId ? "Buy" : ""}}{{!data.buyId ? "Sell" : ""}}</td> -->
                          <td class="text-center">{{moment(data.tradeDate).format("MM/DD/YYYY") }}</td>
                          <td class="text-center">{{moment(data.settlementDate).format("MM/DD/YYYY") }}</td>
                          <td class="text-center">{{data.cusip}}</td>
                          <td class="text-center">{{data.quantity}}</td>
                          <td class="text-center">{{data.price | currency}}</td>
                          <td class="text-center">{{data.principalAmnt | currency}}</td>
                          <td class="text-center">{{data.interest | currency}}</td>
                          <td class="text-center">{{data.commConcAmount | currency}}</td>
                          <td class="text-center">{{data.referenceNo}}</td>
                          <!-- <td class="text-center">{{data.primaryAcctHolder}}</td> -->
                          <td class="text-center">{{data.acctType}}</td>
                          <td class="text-center">{{data.execBrokerMinor}}</td>
                          <td class="text-center">{{data.securityType}}</td>
                          <td class="text-center">{{data.repCode}}</td>
                          <td class="text-center border-right">{{data.fbsiShortName}}</td>
                          <td class="text-center">{{data.settled}}</td>
                          <td class="text-center">{{data.firstName}}</td>
                          <td>
                            <a  @click="editTrade(data)" class="btn ibtn grn"><i class="fas fa-pencil-alt"></i></a>
                            <!-- <button @click="assignTrade(data)" class="btn btn-primary" title="Assign Trader">Assign Trader</button> -->

                          </td>
                      </tr>
                      </tbody>
                  </table>
                  <!-- Pagination-->
                  <b-pagination
                      class="mt-4"
                      :total-rows="totalRows"
                      v-model="currentPage"
                      :per-page="perPage"
                      @input="getPLList(currentPage)"
                  ></b-pagination>
                  <div class="total-records">
                      <span>Total Records : {{totalRows}}</span>
                  </div>
                  </div>
              </div>
              </div>
      </div>
      <edittrade
          v-if="editTradeModalOpen"
          v-bind:tradeData="tradeData"
          @close="closeEditTradePoup()"
      ></edittrade>
      <assigntrade
          v-if="editAssignTradeModalOpen"
          v-bind:tradeData="tradeData"
          @close="closeAssignTradePoup()"
      ></assigntrade>
      <AddTrade
        v-if="addTradeModalOpen"
        v-bind:tradeDataCopy="selectedTrades"
        @close="toggleAddTradePoup()"
        >
      </AddTrade>
  </div>
</template>
<script>
import authService from "@/authService";
import config from "@/config";
import Datepicker from 'vuejs-datepicker';
import edittrade from './ImsProfitLossEditTrade.vue'
import assigntrade from './ImsProfitLossAssignTrader.vue'
import AddTrade from './ImsProfitLossAddTradeModal.vue'
import Swal from 'sweetalert2';

export default {
  name: "imsPLComponentSells",
  components : {
      Datepicker,
      edittrade,
      assigntrade,
      AddTrade
  },
  data() {
    return {
        accessToken:null,
        loading : false,
        currentPage: 1,
        perPage: 10,
        searchValue : "",
        totalRows : 0,
        sortColumn: "tradeDate",
        sortOrder: "DESC",
        plModalOpen : false,
        PlList:[],
        showFilters : false,
        sellModalOpen : false,
        sellData : null,
        fromDate : "",
        toDate : "",
        tradeData : null,
        editTradeModalOpen : false,
        editAssignTradeModalOpen : false,
        isAdmin : false,
        isTrader : false,
        isEditor : false,
        isSuperAdmin : false,
        accountList: [],
        filterAccounts : [],
        filterCusips : [],
        isSettiled : false,
        addTradeModalOpen : false,
        cusipList : [],
        isIgnored : false,
        traderList:[],
        filterTrader : [],
        transactionTypes : ["Trade Profit","Off-Board Transactions","Sales Credit","End of month"],
        settlementStatus : ["SETTLED","NOT_SETTLED","ANY"],
        filterSettlementStatus  : "NOT_SETTLED",
        filterTransactionType : [],
        selectedTrades : [],
        isRemoved : false,
        isStandAlone : false,
        loadingMark : false,
        loadingUnmark : false


    };
  },
  methods: {
    removedOptionChange(){
      if(this.isRemoved){
        this.isIgnored = false;
        this.isSettiled = false;
      }
    },
    getCommissions(){
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/pnl/commissions",
            auth
        )
        .then(result => {
          this.transactionTypes = this.transactionTypes.concat(result.data.map((data) => {return data.commissionName}));
          this.loading = false;

        })        
    },
    toggleAddTradePoup(){
      this.addTradeModalOpen = !this.addTradeModalOpen;
      this.selectedTrades = [];
      if(this.addTradeModalOpen){
        this.PlList.forEach(trade => {
          if(trade.isSelect){
             this.selectedTrades.push(trade);
          }
      });
      }
      this.getPLList(); 
    },
    closeEditTradePoup(){
      this.editTradeModalOpen = false
      this.getPLList(); 
    },
    closeAssignTradePoup(){
      this.editAssignTradeModalOpen = false
      this.getPLList(); 
    },
    assignTrade(data){
      this.tradeData = data;
      this.tradeData.type = "SELL";
      this.editAssignTradeModalOpen = true;
    },
    editTrade(data){
      this.tradeData = data;
      this.tradeData.type = "SELL";
      this.editTradeModalOpen = true;
    },
    search(){
        
    },
    clearSearch(){
      this.searchValue = "";
       
    },
    sort(column){
        this.sortColumn = column;
        this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
        this.getPLList();
    },
    clearFilter(){
      this.filterAccounts = [];
      this.filterCusips = [];
      this.filterTrader = [];
      this.filterTransactionType = [];
      this.isSettiled = false;
      this.fromDate = "";
      this.toDate = "";
      this.isIgnored = false;
      this.isStandAlone = false;
      this.filterSettlementStatus = "NOT_SETTLED"
      this.getPLList();
    },
    getTraderList(){
      this.loading = true;
      const auth = {
        headers: { 'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/pnl/trader-list?page=1&size=100&search=&status=ACTIVE&sortColumn=firstName&sortOrder=ASC&group="+this.tenantName+"-Trader",
            auth
        )
        .then(result => {
          this.traderList = result.data.content.filter((e) => {return e.traderId != null});
           if(this.$route.query.traderId){
              this.traderList.forEach(element => {
                if(element.traderId == this.$route.query.traderId){
                  this.filterTrader.push(element);
                }
              });
              this.showFilters = true;
            }
            this.getPLList();
        })
        .catch(e => {
          console.log(e);
        });
    },
    async remapTrades(){
      const { value: cusip } = await Swal.fire({
        title: "Use this option to remap all trades for a cusip. This is meant to be used in the case of any calculation errors to allow the system to attempt a correction automatically.",
        input: "text",
        inputLabel: "CUSIP",
        inputPlaceholder: "CUSIP",
        showCancelButton: true,
        confirmButtonText: "Remap",
        inputValidator: (value) => {
          if (!value) {
            return "Enter CUSIP";
          }
        }
      });
      if (cusip) {
        this.remapCusip(cusip)
      }
    },
    remapCusip(cusip) {
        const auth = {
            headers: { 'org-token': authService.getOrgToken() }
        };
        let data ={
            "shouldHandleUnMappableSells": false,
            "cusips": [cusip]
        }
        this.$http
            .post(
                config.baseUrlAutoBidder +
                "/pnl/remap-all",
                data,
                auth
            )
            .then(() => {
              this.$alert("Trade remapped successfully", "", "success");
              this.getPLList();
            });
    },
    deleteTrades() {
      this.getPLRemapStatus().then((result) => {
        if (result.data.remapOngoing) {
          this.$alert(this.appMessages.plRemapMessage, "", "warning");
        } else {
          var addData = {
            "buyIds": [],
            "sellIds": [],
            "cognitoSub" : authService.getUser().cognitoSub
          }
          this.PlList.forEach(trade => {
            if (trade.isSelect) {
              if (trade.buyId) addData.buyIds.push(trade.buyId);
              if (trade.sellId) addData.sellIds.push(trade.sellId);
            }
          });
          if (addData.buyIds.length == 0 && addData.sellIds.length == 0) {
            this.$alert("Please select any trade", "", "error");
            return false
          }
          // if(addData.sellIds.length == 0 ){
          //   this.$alert("Please select any sell","","error");
          //   return false
          // }
          var message = `Are you sure you want to delete?`;
          this.$confirm(message, "", "warning", { confirmButtonText: "DELETE", cancelButtonText: "NO" }).then(() => {
            this.loading = true;
            const auth = {
              headers: { 'org-token': authService.getOrgToken() }
            };
            this.$http
              .post(config.baseUrlBidSide + "/pnl/delete-trade", addData, auth)
              .then(() => {
                this.$alert("Trade deleted successfully", "", "success");
                this.getPLList();
                this.loading = false;
              })
              .catch(e => {
                console.log(e.response);
                this.loading = false;
              });
          })
        }
      })
    },
    mapTrades() {
      this.getPLRemapStatus().then((result) => {
        if (result.data.remapOngoing) {
          this.$alert(this.appMessages.plRemapMessage, "", "warning");
        } else {
          var addData = {
            "buyIds": [],
            "sellIds": [],
            "cognitoSub": authService.getUser().cognitoSub
          }
          this.PlList.forEach(trade => {
            if (trade.isSelect) {
              if (trade.buyId) addData.buyIds.push(trade.buyId);
              if (trade.sellId) addData.sellIds.push(trade.sellId);
            }
          });
          console.log("data", addData)
          if (addData.buyIds.length == 0) {
            this.$alert("Please select any buy", "", "error");
            return false
          }
          if (addData.sellIds.length == 0) {
            this.$alert("Please select any sell", "", "error");
            return false
          }
          this.loading = true;
          const auth = {
            headers: { 'org-token': authService.getOrgToken() }
          };
          this.$http
            .post(config.baseUrlBidSide + "/pnl/map-trades", addData, auth)
            .then(() => {
              this.$alert("Trades mapped successfully", "", "success");
              this.getPLList();
              this.loading = false;
            })
            .catch(e => {
              console.log(e.response);
              this.loading = false;
            });

        }
      })
    },
    markTrades() {
      this.getPLRemapStatus().then((result) => {
        if (result.data.remapOngoing) {
          this.$alert(this.appMessages.plRemapMessage, "", "warning");
        } else {
          var addData = {
            "buyIds": [],
            "sellIds": [],
            "cognitoSub": authService.getUser().cognitoSub
          }
          this.PlList.forEach(trade => {
            if (trade.isSelect) {
              if (trade.buyId) addData.buyIds.push(trade.buyId);
              if (trade.sellId) addData.sellIds.push(trade.sellId);
            }
          });
          if (addData.buyIds.length == 0 && addData.sellIds.length == 0) {
            this.$alert("Please select any trade", "", "error");
            return false
          }
          this.loadingMark = true;
          const auth = {
            headers: { 'org-token': authService.getOrgToken() }
          };
          this.$http
            .post(config.baseUrlAutoBidder + "/pnl/mark-stand-alone", addData, auth)
            .then(() => {
              this.$alert("Selected trades have been marked as stand-alone", "", "success");
              this.getPLList();
              this.loadingMark = false;
            })
            .catch(e => {
              console.log(e.response);
              this.loadingMark = false;
            });

        }
      });
    },
    unmarkTrades() {
      this.getPLRemapStatus().then((result) => {
        if (result.data.remapOngoing) {
          this.$alert(this.appMessages.plRemapMessage, "", "warning");
        } else {
          var addData = {
            "buyIds": [],
            "sellIds": [],
            "cognitoSub": authService.getUser().cognitoSub
          }
          this.PlList.forEach(trade => {
            if (trade.isSelect) {
              if (trade.buyId) addData.buyIds.push(trade.buyId);
              if (trade.sellId) addData.sellIds.push(trade.sellId);
            }
          });
          if (addData.buyIds.length == 0 && addData.sellIds.length == 0) {
            this.$alert("Please select any trade", "", "error");
            return false
          }
          // console.log("data",addData)
          // if(addData.buyIds.length == 0 ){
          //   this.$alert("Please select any buy","","error");
          //   return false
          // }
          // if(addData.sellIds.length == 0 ){
          //   this.$alert("Please select any sell","","error");
          //   return false
          // }
          this.loadingUnmark = true;
          const auth = {
            headers: { 'org-token': authService.getOrgToken() }
          };
          this.$http
            .post(config.baseUrlAutoBidder + "/pnl/unmark-stand-alone", addData, auth)
            .then(() => {
              this.$alert("Selected trades have been unmarked as stand-alone", "", "success");
              this.getPLList();
              this.loadingUnmark = false;
            })
            .catch(e => {
              console.log(e.response);
              this.loadingUnmark = false;
            });

        }
      });
    },
    getPLList(currentPage,download){
      this.loading = true;
      // if (!currentPage) {
      //   currentPage = 1;
      // }
      if(this.isRemoved){
        this.isIgnored = false;
        this.isSettiled = false;
      }
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      var fDate = this.fromDate ? this.moment(this.fromDate).format("YYYY-MM-DD") : "";
      var tDate = this.toDate ? this.moment(this.toDate).format("YYYY-MM-DD") : "";
      var filterTrader =  this.filterTrader.map((e) => {return e.traderId}).toString();
      //if trader only user login only need logged traders data
      if(this.isTrader && !this.isAdmin && !this.isEditor && !this.isSuperAdmin){
        if(authService.getUser().traderId){
          filterTrader = authService.getUser().traderId;
        }
      }
      let url = "/pnl/list-all";
      this.$http
        .get(
          config.baseUrlBidSide +
            url+"?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&fromDate="+
            fDate+
            "&toDate="+
            tDate+
            "&accounts="+
            this.filterAccounts.toString()+
            "&cusips="+
            this.filterCusips.toString()+
            "&settlementStatus="+
            (this.filterSettlementStatus ? this.filterSettlementStatus : "") +
            "&ignored="+
            this.isIgnored+
            "&removed="+
            this.isRemoved+
            "&isStandAlone="+
            this.isStandAlone+
            "&traderIds="+
            filterTrader+
            "&transactionType="+
            this.filterTransactionType.toString(),
            auth

        )
        .then(result => {
            this.loading = false;
            if(download){
              window.open(result.data, "_blank");
            }else{
              this.totalRows = result.data.pageInfo.totalElements;
              this.PlList = result.data.content;
            }
        })
        .catch(e => {
          console.log("Error", e);
          //self.loading = false;
        });
    },
    getAccountList(){
      const auth = {
        headers: { 'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/pnl/accounts",
            auth
        )
        .then((result) => {
          this.accountList = result.data;
        })
    },
    getCusipList(){
      const auth = {
        headers: { 'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/pnl/cusips",
            auth
        )
        .then(result => {
          this.cusipList = result.data;
        })
    },
    getLastImportedDate(){
       const auth = {
        headers: { 'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/pnl/latest-import-date?cognitoSub="+authService.getUser().cognitoSub,
            auth
        )
        .then(result => {
          if(result.data.from && !this.$route.query.fromdate){
            this.fromDate = result.data.from;
            this.toDate = result.data.to;
            this.showFilters = true;
          }
          this.getTraderList();
        })
    }
  },
  mounted() {
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.accessToken = result;
        this.$cognitoAuth.getUserGroup((err, role) => {
          if (err) {
            console.log("accessToken is not found", err);
          } else {
            this.tenantName = role[0].split("-")[0];
            var roleArray = role.map(item => {
              return  item.split("-")[1];
            })
            roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
            roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
            roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
            roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;
            // this.fromDate = this.moment().format("YYYY-MM-DD");
            // this.toDate = this.moment().add(1,'days').format("YYYY-MM-DD");
            if(this.$route.query.transactionType){
              this.filterTransactionType.push(this.$route.query.transactionType);
              this.showFilters = true;
            }
            if(this.$route.query.repCode){
              this.filterRepCode.push(this.$route.query.repCode);
              this.showFilters = true;
            }
            if(this.$route.query.fromdate){
              this.fromDate = this.$route.query.fromdate
            }
            if(this.$route.query.todate){
              this.toDate = this.$route.query.todate
            }
            if(this.$route.query.isSettiled){
              this.isSettiled = true;
            }
            this.getLastImportedDate();
            //this.getTraderList();
            //this.getPLList();
            this.getAccountList();
            this.getCusipList();
            this.getCommissions();

            // this.getRepCodeList();

          }
        });
        
        
      }
    });
     
  }
};
</script>
<style scoped>
.map-trade button{
    padding: 5px 15px!important;
}
</style>